import type { IconProps } from "@tabler/icons-react";
import { clsx } from "clsx";
import { type ReactElement, type ReactNode, cloneElement } from "react";

interface LinkItemProps {
	isActive?: boolean;
	icon: ReactElement<IconProps>;
	label?: string | undefined;
	suffix?: ReactNode;
}

export const LinkItem = ({ isActive, label, icon, suffix }: LinkItemProps) => {
	if (!label) {
		return (
			<div
				className={clsx(
					// p-3: same 28px icon edge as the open state's mx-4 + pl-3, so
					// icons don't shift horizontally when the sidebar collapses.
					"rounded-xs p-3",
					isActive ? "bg-white" : "hover:bg-white/60",
				)}
			>
				{cloneElement<IconProps>(icon, {
					size: 16,
					strokeWidth: 1.5,
					className: "size-4 text-primary-600/60",
				})}
			</div>
		);
	}

	return (
		<div
			className={clsx(
				// pl-3: matches the picker card and "Menu" label's own mx-4 + p-3
				// inset, so the icon lines up with their left edge, not the row's.
				"flex h-9 items-center gap-3 rounded-xs py-2.5 pl-3 pr-3",
				isActive ? "bg-white" : "hover:bg-white/60",
			)}
		>
			<div className="shrink-0">
				{cloneElement<IconProps>(icon, {
					size: 16,
					strokeWidth: 1.5,
					className: "size-4 text-primary-600/60",
				})}
			</div>
			<div className="flex items-center gap-2">
				<div
					className={clsx(
						"text-sm font-medium leading-5",
						isActive ? "text-black" : "text-primary-800",
					)}
				>
					{label}
				</div>
				{suffix}
			</div>
		</div>
	);
};
